<template>
  <v-dialog persistent width="90%" v-model="disciplinaAdministrativaDialog">
    <template v-slot:activator="{ on, attrs }">
      <v-btn color="secondary" class="mx-2" v-on="on" v-bind="attrs">Disciplina Administrativa</v-btn>
    </template>
    <v-card color="primary" class="rounded-sm">
      <v-card-title>
        <div class="text-h6">Evaluación de disciplina administrativa</div>
        <v-spacer></v-spacer>
        <v-btn icon color="error" @click="closeDialog()"><v-icon>mdi-window-close</v-icon></v-btn>
      </v-card-title>
      <v-card-text v-if="disciplinaAdministrativa">
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-card elevation="4" class="rounded-sm">
                <v-card-title>
                  <div class="text-subtitle-1 font-weight-bold">Información general</div>
                </v-card-title>
                <v-card-text>
                  <InformacionGeneralEvaluacionSection :evaluacion="disciplinaAdministrativa" />
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12">
              <TiposIncidenciaForm :incidencias="disciplinaAdministrativa.incidencias" />
            </v-col>
            <v-col>
              <ActasAdministrativasForm :actas-administrativas="disciplinaAdministrativa.actasAdministrativas" />
            </v-col>
            <v-col>
              <EstimulosForm :estimulos="disciplinaAdministrativa.estimulos" />
            </v-col>
            <v-col>
              <ReconocimientosForm :reconocimientos="disciplinaAdministrativa.reconocimientos" />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions class="justify-center">
        <TextButton
          color="secondary"
          @click="triggerSaveDisciplinaAdministrativa()"
          :loading="loading"
          v-if="!isPerfilPolicia"
        >
          Guardar evaluación
        </TextButton>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import UpdateEvaluacionDisciplinaAdministrativaUseCase from '@src/modules/evaluacion-desempeño/application/usecases/UpdateEvaluacionDisciplinaAdministrativa.usecase'
import { mapActions } from 'vuex'
import EvaluacionDisciplinaAdministrativaApiRepository from '@src/modules/evaluacion-desempeño/infrastructure/EvaluacionDisciplinaAdministrativaApi.repository'
import TiposIncidenciaForm from './evaluacion-desempeño/disciplina-administrativa/forms/TiposIncidenciaForm.vue'
import ActasAdministrativasForm from './evaluacion-desempeño/disciplina-administrativa/forms/ActasAdministrativasForm.vue'
import EstimulosForm from './evaluacion-desempeño/disciplina-administrativa/forms/EstimulosForm.vue'
import ReconocimientosForm from './evaluacion-desempeño/disciplina-administrativa/forms/ReconocimientosForm.vue'
import InformacionGeneralEvaluacionSection from './evaluacion-desempeño/common/InformacionGeneralEvaluacionSection.vue'
import { PERFILES } from '@/perfiles.js'
import TextButton from '@src/components/base/TextButton.vue'

export default {
  components: {
    TiposIncidenciaForm,
    ActasAdministrativasForm,
    EstimulosForm,
    ReconocimientosForm,
    InformacionGeneralEvaluacionSection,
    TextButton,
  },

  props: {
    disciplinaAdministrativa: {
      type: Object,
    },
  },

  data() {
    return {
      disciplinaAdministrativaDialog: false,
      loading: false,
    }
  },

  computed: {
    isPerfilPolicia() {
      const perfilLocal = localStorage.getItem('perfil')?.toLowerCase().trim()
      const perfilConst = PERFILES.Policia?.toLowerCase().trim()
      return perfilLocal === perfilConst
    },
  },
  methods: {
    ...mapActions('disciplinaAdministrativa', ['updateDisciplinaAdministrativa']),

    closeDialog() {
      this.loading = false
      this.disciplinaAdministrativaDialog = false
    },

    async triggerSaveDisciplinaAdministrativa() {
      this.loading = true

      new UpdateEvaluacionDisciplinaAdministrativaUseCase(
        new EvaluacionDisciplinaAdministrativaApiRepository()
      ).execute(this.disciplinaAdministrativa)

      this.closeDialog()
    },
  },
}
</script>
